import React, { Component } from "react";
import TextInputField, { Props as TFProps } from "./TextInputField";
import { DefaultProps, NullableFormValue } from "@eres/forms";
import NumberConverter from "@eres/forms/converters/NumberConverter";
import { readValue, writeValue } from "@eres/forms/Utils";

export interface Props extends TFProps<number> {
	minValue?: number;
	maxValue?: number;
}

interface State {
}

class CountInputField extends Component<Props, State> {
	static defaultProps: DefaultProps<Props> = {};
	updateNewValue = ( v: number ) => {
		if ( this.props.minValue != undefined && v < this.props.minValue ) {
			v = this.props.minValue;
		}
		if ( this.props.maxValue != undefined && v > this.props.maxValue ) {
			v = this.props.maxValue;
		}
		writeValue( this.props, v );
	};
	decrementValue = () => {
		let v = Number( readValue( this.props ) );
		if ( !v ) v = 0;
		v = Number( v ) - 1;
		this.updateNewValue( v );

	};
	incrementValue = () => {
		let v = Number( readValue( this.props ) );
		if ( !v ) v = 0;
		v = Number( v ) + 1;
		this.updateNewValue( v );
	};
	renderInput = ( props: Props, inpProps: any ) => {
		return <div className={ "input-group" }>
			<button className={ "btn btn-a " } onClick={ this.decrementValue }><i className={ "fa fa-minus-circle" }/>
			</button>

			<input { ...inpProps }/>
			<button className={ "btn btn-a" } onClick={ this.incrementValue }><i className={ "fa fa-plus-circle" }/>
			</button>
		</div>;
	};
	handleUpdate = ( value: NullableFormValue<string, number>, extra?: any ) => {
		this.updateNewValue( Number( value ) );
	};

	render() {
		return <TextInputField
			onValueUpdated={ this.handleUpdate }
			valueConverter={ NumberConverter }
			{ ...this.props }
			inputRenderer={ this.renderInput }
			extraInputClassName={ "text-end" }/>;
	}

}

export default CountInputField;
